import React, { Component } from 'react';
import {
    BroadCastSession,
    ClassroomSession,
    InPerson,
    OnDemand,
    Scheduled,
} from '../../../utils/common/NamingTerms';
import LanguageContext, { LanguageProvider } from '../../../utils/common/LanguageContext';

class SessionType extends Component {
    // Render Sesstion Type
    renderSessionType(status) {
        switch (status) {
            case ClassroomSession:
                return (
                    <p
                        className={`font-normal text-base leading-6 text-[#F6F8FB] ${
                            this.props.className ? this.props.className : 'mb-0'
                        }`}
                    >
                        {this.props.t('group')}
                    </p>
                );
            case 'ONE_TO_ONE':
                return (
                    <p
                        className={`font-normal text-base leading-6 text-[#F6F8FB] ${
                            this.props.className ? this.props.className : 'mb-0'
                        }`}
                    >
                        {this.props.t('oneToOne')}
                    </p>
                );
            case OnDemand:
                return (
                    <p
                        className={`font-normal text-base leading-6 text-[#F6F8FB] ${
                            this.props.className ? this.props.className : 'mb-0'
                        }`}
                    >
                        {this.props.t('onDemand')}
                    </p>
                );
            case Scheduled:
                return (
                    <p
                        className={`font-normal text-base leading-6 text-[#F6F8FB] ${
                            this.props.className ? this.props.className : 'mb-0'
                        }`}
                    >
                        {this.props.t('appointment')}
                    </p>
                );
            case BroadCastSession:
                return (
                    <p
                        className={`font-normal text-base leading-6 text-[#F6F8FB] ${
                            this.props.className ? this.props.className : 'mb-0'
                        }`}
                    >
                        {this.props.t('liveStreamBroadcast')}
                    </p>
                );
            case InPerson:
                return (
                    <p
                        className={`font-normal text-base leading-6 text-[#F6F8FB] ${
                            this.props.className ? this.props.className : 'mb-0'
                        }`}
                    >
                        {this.props.t('inPerson')}
                    </p>
                );
            case 'CONFERENCE_CALL':
                return (
                    <p
                        className={`font-normal text-base leading-6 text-[#F6F8FB] ${
                            this.props.className ? this.props.className : 'mb-0'
                        }`}
                    >
                        {this.props.t('conferenceSession')}
                    </p>
                );
            default:
                return <div>-</div>;
        }
    }

    // Render Sesstion Type For Dashboard
    renderDashboardSessionType(status) {
        switch (status) {
            case 'CLASS_ROOM_SESSION':
                return (
                    <p
                        className={`text-base ${
                            !this.props.isFromDashboardAppointment
                                ? 'font-normal leading-6 text-white sm:mb-0 mb-3'
                                : ''
                        }`}
                    >
                        {this.props.t('groupSession')}
                    </p>
                );
            case 'ONE_TO_ONE':
                return (
                    <p
                        className={`text-base ${
                            !this.props.isFromDashboardAppointment
                                ? 'font-normal leading-6 text-[#F6F8FB] sm:mb-0 mb-3'
                                : ''
                        }`}
                    >
                        {this.props.t('oneToOne')}
                    </p>
                );
            case OnDemand:
                return (
                    <p
                        className={`text-base ${
                            !this.props.isFromDashboardAppointment
                                ? 'font-normal leading-6 text-[#F6F8FB] sm:mb-0 mb-3'
                                : ''
                        }`}
                    >
                        {this.props.t('onDemand')}
                    </p>
                );
            case Scheduled:
                return (
                    <p
                        className={`text-base ${
                            !this.props.isFromDashboardAppointment
                                ? 'font-normal leading-6 text-[#F6F8FB] sm:mb-0 mb-3'
                                : ''
                        }`}
                    >
                        {this.props.t('appointment')}
                    </p>
                );
            case 'BROADCAST_SESSION':
                return (
                    <p
                        className={`text-base ${
                            !this.props.isFromDashboardAppointment
                                ? 'font-normal leading-6 text-[#F6F8FB] sm:mb-0 mb-3'
                                : ''
                        }`}
                    >
                        {this.props.t('liveStreamBroadcast')}
                    </p>
                );
            case InPerson:
                return (
                    <p
                        className={`text-base ${
                            !this.props.isFromDashboardAppointment
                                ? 'font-normal leading-6 text-[#F6F8FB] sm:mb-0 mb-3'
                                : ''
                        }`}
                    >
                        {this.props.t('inPerson')}
                    </p>
                );
            case 'CONFERENCE_CALL':
                return (
                    <p
                        className={`text-base ${
                            !this.props.isFromDashboardAppointment
                                ? 'font-normal leading-6 text-[#F6F8FB] sm:mb-0 mb-3'
                                : ''
                        }`}
                    >
                        {this.props.t('conferenceSession')}
                    </p>
                );
            default:
                return <div>-</div>;
        }
    }

    render() {
        return (
            <>
                {!this.props.isFromDashboard
                    ? this.renderDashboardSessionType(this.props.sessionType)
                    : this.renderSessionType(this.props.sessionType)}
            </>
        );
    }
}

const withLanguage = (WrappedComponent) => {
    return class extends Component {
        render() {
            return (
                <LanguageContext.Consumer>
                    {({ t }) => <WrappedComponent {...this.props} t={t} />}
                </LanguageContext.Consumer>
            );
        }
    };
};

const SessionTypeWithLanguage = withLanguage(SessionType);

export default (props) => (
    <LanguageProvider>
        <SessionTypeWithLanguage {...props} />
    </LanguageProvider>
);
